import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@arcadeai/design-system/components/ui/atoms/popover";
import { BanIcon } from "lucide-react";
import { useState } from "react";
import { useDeleteConnectedAccounts } from "@/app/oauth/api/hooks";
import type { ConnectedAccountItem } from "@/app/oauth/types";

type DeleteActionProps = {
  account: ConnectedAccountItem;
};

export function DeleteAction({ account }: DeleteActionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { mutate: deleteConnectedAccounts } = useDeleteConnectedAccounts();

  const handleDelete = () => {
    deleteConnectedAccounts({
      connectionId: account.connection_id,
    });
    setIsOpen(false);
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger
        render={
          <Button
            className="cursor-pointer border border-destructive/60 bg-destructive/20 transition-colors duration-200 hover:bg-destructive/30"
            disabled={account.connection_status === "revoked"}
            size="sm"
            variant="secondary"
          />
        }
      >
        <BanIcon className="size-4" />
        <span className="hidden lg:block">Revoke</span>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">Revoke Connection</h4>
            <p className="text-muted-foreground text-sm">
              Are you sure you want to revoke this connection? This action
              cannot be undone.
            </p>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              onClick={() => setIsOpen(false)}
              size="sm"
              variant="outline"
            >
              Cancel
            </Button>
            <Button onClick={handleDelete} size="sm" variant="destructive">
              Revoke
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
